// extracted by mini-css-extract-plugin
module.exports = {"default":"style_default__1n8XC","blue":"style_blue__1yMt5","green":"style_green__3SD0m","red":"style_red__2SgXH"};